import { render } from "./ShoppingItemsList.vue?vue&type=template&id=3cbad43e"
import script from "./ShoppingItemsList.vue?vue&type=script&lang=js"
export * from "./ShoppingItemsList.vue?vue&type=script&lang=js"

import "./ShoppingItemsList.vue?vue&type=style&index=0&id=3cbad43e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__